import { Button, Typography } from "@king-ict/eupisi-ui/components";
import { FormGroup, FormLabel, FormText, FormControl } from "react-bootstrap";

import styles from "./ButtonWithValidation.module.scss";

export interface ButtonWithValidationProps {
    children?: any;
    color?: "primary" | "success" | "danger" | "warning";
    className?: string;
    onClick?: (event: React.MouseEvent<any, MouseEvent>) => void;
    onMouseOver?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onMouseOut?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    disabled?: boolean;
    size?: "sm" | "lg";
    outline?: boolean;
    icon?: any;
    ref?: any;
    boxless?: boolean;
    errorText?: string;
  }

export const ButtonWithValidation = (props: ButtonWithValidationProps) => {

    return(
        <>
        <FormGroup className={props.className}>            
            <FormLabel className={`${styles.buttonLabel} ${styles.errorText}`}></FormLabel>           
            <Button                                
                color={props.errorText ? "danger" : props.color}                
                className={styles.button}
                onClick={props.onClick}
                onMouseOver={props.onMouseOver}
                onMouseOut={props.onMouseOut}
                disabled={props.disabled}
                size={props.size}
                outline={props.outline}
                icon={props.icon}
                ref={props.ref}
                boxless={props.boxless}                
            >
                {props.children}
            </Button> 
            {props.errorText &&                              
                <FormText className={`${styles.helperText} ${styles.errorText}`}>
                    <Typography color="danger"  variant="small">{props.errorText}</Typography>
                </FormText>       
            }
        </FormGroup>

        </>
    );

};